import React from 'react';
import styled from 'styled-components';

import css from 'css';
import {
    h1Styles,
    h2Styles,
    h3Styles,
    h4Styles,
    h5Styles,
    h6Styles,
    pStyles,
} from 'partials/typography';

const Html = props => <Wrapper content={props.content ? 'yes' : 'no'} className={props.className} dangerouslySetInnerHTML={{ __html: props.children }} />

export default Html;

const Wrapper = styled.div`
    ${props => props.content === 'yes' ? `
        p {
            ${pStyles}
            margin: 0 0 25px;
        }
        h1 {
            ${h1Styles}
            margin-bottom: 25px;
        }
        h2 {
            ${h2Styles}
            margin-bottom: 25px;
        }
        h3 {
            ${h3Styles}
            margin-bottom: 25px;
        }
        h4 {
            ${h4Styles}
            margin-bottom: 25px;
        }
        h5 {
            ${h5Styles}
            margin-bottom: 25px;
        }
        h6 {
            ${h6Styles}
            margin-bottom: 25px;
        }
        strong, b {
            ${css.fonts.SSProSemiBold}
        }
        em {
            font-style: italic;
        }
        blockquote {
            ${css.fonts.SpectralBold}
            font-size:24px;
            line-height:32px;
            position:relative;
            &:before {
                content: '';
                display: block;
                width:2px;
                height:100%;
                position:absolute;
                left:-24px;
                top:0;
                background: ${css.colors.blue};
            }
            p {
                ${css.fonts.SpectralBold}
                font-size:24px;
                line-height:32px; 
                &:before {
                    content: '«';
                    padding-right:5px;
                }
                &:after {
                    content: '»';
                    padding-left:5px;
                }
            }
            em {
                
            }
        }
        ul {
            padding-left:20px;
            margin-bottom:25px;
            li {
                font-size:16px;
                margin-bottom:10px;
                list-style: none;
                position:relative;
                &:before {
                    content: '';
                    display: block;
                    width:8px;
                    height:8px;
                    position:absolute;
                    left: -20px;
                    top: 10px;
                    background: ${css.colors.blue};
                    border-radius: 8px;
                }
            }
        }
        ol {
            padding-left:20px;
            margin-bottom:25px;
            li {
                font-size:16px;
                margin-bottom:10px;
                list-style: decimal;
            }
        }
        a {
            color: ${css.colors.main};
            text-decoration:none;
            border-bottom: 1px solid ${css.colors.blue};
            &:hover, &:focus {
                color: ${css.colors.blue};
                text-decoration: none;
            }
        }
        img.alignleft {
            float:left;
            margin: 0 20px 20px 0;
        }
        img.alignright {
            float:right;
            margin: 0 0 20px 20px;
        }
        img.aligncenter {
            margin: 0 auto 20px;
        }
        .excerpt {
            p {
                ${h2Styles}
            }
        }
        .button {
            a {
                height:48px;
                display: inline-flex;
                align-items:center;
                padding:0 30px;
                border: 2px solid ${css.colors.red};
                font-size:18px;
                transition: all .1s ease-in-out;
                &:hover {
                    color: ${css.colors.main}!important;
                    border: 2px solid ${css.colors.red};
                    background: ${css.colors.red};
                }
            }
        }
    ` : ``}
`


// WEBPACK FOOTER //
// ./src/partials/Html.js